import { create } from 'zustand';

const useAvailabilityStore = create((set, get) => ({
  openModal: false,
  setOpenModal: (openModal) => set(() => ({ openModal })),
  message: '',
  setMessage: (message) => set(() => ({ message })),
  onCloseModalCallback: null,
  setOnCloseModalCallback: (callback) => set(() => ({ onCloseModalCallback: callback })),
}));

export default useAvailabilityStore;
